import { IMAGES_CDN_VERSION_PATH } from './__generated__/config.js';

// This file is auto-generated by scripts/set-images-cdn-path.js during npm install or npm run build.
var CDN_BASE_PATH = "https://reconvert-cdn.com/react-ui-component/".concat(IMAGES_CDN_VERSION_PATH)
    ;

export { CDN_BASE_PATH };
//# sourceMappingURL=config.js.map
